import { render, staticRenderFns } from "./FooterCompliance.vue?vue&type=template&id=e48edf9c&scoped=true"
import script from "./FooterCompliance.vue?vue&type=script&lang=js"
export * from "./FooterCompliance.vue?vue&type=script&lang=js"
import style0 from "./FooterCompliance.vue?vue&type=style&index=0&id=e48edf9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48edf9c",
  null
  
)

export default component.exports